import { Link } from "react-router-dom";

const Checkout = () => {
  return (
    <>
      <div
        className="inner-banner banner"
        style={{ background: 'url("images/payment-banner.jpg")' }}
      >
        <div className="container">
          <div className="inner-banner-txt text-white">
            <h1 className="banner-banner-heading fs-45 text-white">
              Secure Checkout
            </h1>
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/cart">Cart</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Secure Checkout{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="main-section checkout-page border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-sm-5 col-xs-12 order-2 mob-order-1 mb-4">
              <div className="quick-checkout bg-light p-4">
                <h4 className="d-flex justify-content-between align-items-center mb-3">
                  <span>
                    {" "}
                    <span className="mbri-shopping-bag">
                      <sup className="fs-13"> </sup>
                    </span>
                    Your Order
                  </span>
                </h4>
                <div className="ch-order-detail">
                  <a href="#" className="btn w-100">
                    Continue
                  </a>
                  <div className="cart-item">
                    <p className="total-amount">
                      Items <span>3</span>
                    </p>
                    <p className="total-amount">
                      Order Subtotal <span>$190</span>
                    </p>
                    <p className="total-amount">
                      Tax <span>$10</span>
                    </p>
                    <p className="total-amount">
                      <big>
                        <strong>Total </strong>
                      </big>
                      <span>
                        <strong>$200.00</strong>
                      </span>
                    </p>
                  </div>
                </div>
                <ul>
                  <li>
                    <div className="cart-item">
                      <div className="cart-item-img">
                        <a href="#">
                          <img
                            src="images/white-top-with-jacket.jpg"
                            alt="jacket"
                          />
                        </a>
                      </div>
                      <div className="cart-item-info">
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <a href="#" tabIndex={0}>
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </a>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del className="tcolor">$70</del>
                          </div>
                          <button className="sm-btn float-right">Delete</button>
                        </div>
                      </div>
                    </div>
                  </li>
                  {/* rept */}
                  <li>
                    <div className="cart-item">
                      <div className="cart-item-img">
                        <a href="#">
                          <img src="images/kasmiri.jpg" alt="jacket" />
                        </a>
                      </div>
                      <div className="cart-item-info">
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <a href="#" tabIndex={0}>
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </a>
                          </h4>
                          <div className="prices">
                            <span>$130</span> <del className="tcolor">$70</del>
                          </div>
                          <button className="sm-btn float-right">Delete</button>
                        </div>
                      </div>
                    </div>
                  </li>
                  {/* rept */}
                  <li>
                    <div className="cart-item">
                      <div className="cart-item-img">
                        <a href="#">
                          <img src="images/whiteshut.jpg" alt="jacket" />
                        </a>
                      </div>
                      <div className="cart-item-info">
                        <div className="prd-info">
                          <h4 className="prd-name">
                            <a href="#" tabIndex={0}>
                              Astron Cotton Blended Regular Tops -
                              <span className="prd-color">Black</span>
                            </a>
                          </h4>
                          <div className="prices">
                            <span>$30</span> <del className="tcolor">$70</del>
                          </div>
                          <button className="sm-btn float-right">Delete</button>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-8 col-sm-7 col-xs-12">
              <h4 className="mb-3">Billing address</h4>
              <form className="needs-validation" noValidate="">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="firstName">First name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="firstName"
                      placeholder=""
                      defaultValue=""
                      required=""
                    />
                    <div className="invalid-feedback">
                      Valid first name is required.
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="lastName">Last name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="lastName"
                      placeholder=""
                      defaultValue=""
                      required=""
                    />
                    <div className="invalid-feedback">
                      Valid last name is required.
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="username">Username</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">@</span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      placeholder="Username"
                      required=""
                    />
                    <div className="invalid-feedback" style={{ width: "100%" }}>
                      Your username is required.
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="email">
                    Email <span className="text-muted">(Optional)</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="you@example.com"
                  />
                  <div className="invalid-feedback">
                    Please enter a valid email address for shipping updates.
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="address">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    placeholder="1234 Main St"
                    required=""
                  />
                  <div className="invalid-feedback">
                    Please enter your shipping address.
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="address2">
                    Address 2 <span className="text-muted">(Optional)</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="address2"
                    placeholder="Apartment or suite"
                  />
                </div>
                <div className="row">
                  <div className="col-md-5 mb-3">
                    <label htmlFor="country">Country</label>
                    <select
                      className="custom-select d-block w-100"
                      id="country"
                      required=""
                    >
                      <option value="">Choose...</option>
                      <option>United States</option>
                    </select>
                    <div className="invalid-feedback">
                      Please select a valid country.
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <label htmlFor="state">State</label>
                    <select
                      className="custom-select d-block w-100"
                      id="state"
                      required=""
                    >
                      <option value="">Choose...</option>
                      <option>California</option>
                    </select>
                    <div className="invalid-feedback">
                      Please provide a valid state.
                    </div>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label htmlFor="zip">Zip</label>
                    <input
                      type="text"
                      className="form-control"
                      id="zip"
                      placeholder=""
                      required=""
                    />
                    <div className="invalid-feedback">Zip code required.</div>
                  </div>
                </div>
                <hr className="mb-4" />
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="same-address"
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="same-address"
                  >
                    Shipping address is the same as my billing address
                  </label>
                </div>
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="save-info"
                  />
                  <label className="custom-control-label" htmlFor="save-info">
                    Save this information for next time
                  </label>
                </div>
                <hr className="mb-4" />
                <h4 className="mb-3">Payment</h4>
                <div className="d-block my-3">
                  <div className="custom-control custom-radio">
                    <input
                      id="credit"
                      name="paymentMethod"
                      type="radio"
                      className="custom-control-input"
                      defaultChecked=""
                      required=""
                    />
                    <label className="custom-control-label" htmlFor="credit">
                      Credit card
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      id="debit"
                      name="paymentMethod"
                      type="radio"
                      className="custom-control-input"
                      required=""
                    />
                    <label className="custom-control-label" htmlFor="debit">
                      Debit card
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      id="paypal"
                      name="paymentMethod"
                      type="radio"
                      className="custom-control-input"
                      required=""
                    />
                    <label className="custom-control-label" htmlFor="paypal">
                      Paypal
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="cc-name">Name on card</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cc-name"
                      placeholder=""
                      required=""
                    />
                    <small className="text-muted">
                      Full name as displayed on card
                    </small>
                    <div className="invalid-feedback">
                      Name on card is required
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="cc-number">Credit card number</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cc-number"
                      placeholder=""
                      required=""
                    />
                    <div className="invalid-feedback">
                      Credit card number is required
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-3 col-sm-6 mb-3">
                    <label htmlFor="cc-expiration">Expiration</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cc-expiration"
                      placeholder=""
                      required=""
                    />
                    <div className="invalid-feedback">
                      Expiration date required
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 mb-3">
                    <label htmlFor="cc-expiration">CVV</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cc-cvv"
                      placeholder=""
                      required=""
                    />
                    <div className="invalid-feedback">
                      Security code required
                    </div>
                  </div>
                </div>
                <hr className="mb-4" />
                <button className="btn" type="submit">
                  Continue to checkout
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;
